import { render, staticRenderFns } from "./addHeader.vue?vue&type=template&id=0a14b43c&scoped=true&"
import script from "./addHeader.vue?vue&type=script&lang=js&"
export * from "./addHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14b43c",
  null
  
)

export default component.exports